module.exports = __webpack_public_path__ + "aee9acf56065e68d9ef6d4dc3d1d6622.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/school/Cafeteria1.jpg
// module id = 3574
// module chunks = 0